function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.91 8.602h-7.518V1.085C11.392.743 10.927 0 9.997 0c-.93 0-1.395.743-1.395 1.085v7.517H1.085C.743 8.602 0 9.067 0 9.997c0 .93.743 1.395 1.085 1.395h7.517v7.517c0 .343.465 1.085 1.395 1.085.93 0 1.395-.742 1.395-1.085v-7.517h7.517c.343 0 1.085-.465 1.085-1.395 0-.93-.742-1.395-1.085-1.395z",
  fill: "#3BB47F"
});

var SvgPlus = function SvgPlus(props) {
  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBkPSJNMTguOTEgOC42MDJoLTcuNTE4VjEuMDg1QzExLjM5Mi43NDMgMTAuOTI3IDAgOS45OTcgMGMtLjkzIDAtMS4zOTUuNzQzLTEuMzk1IDEuMDg1djcuNTE3SDEuMDg1Qy43NDMgOC42MDIgMCA5LjA2NyAwIDkuOTk3YzAgLjkzLjc0MyAxLjM5NSAxLjA4NSAxLjM5NWg3LjUxN3Y3LjUxN2MwIC4zNDMuNDY1IDEuMDg1IDEuMzk1IDEuMDg1LjkzIDAgMS4zOTUtLjc0MiAxLjM5NS0xLjA4NXYtNy41MTdoNy41MTdjLjM0MyAwIDEuMDg1LS40NjUgMS4wODUtMS4zOTUgMC0uOTMtLjc0Mi0xLjM5NS0xLjA4NS0xLjM5NXoiIGZpbGw9IiMzQkI0N0YiLz4KPC9zdmc+Cg==";
export { SvgPlus as ReactComponent };